import boolean from 'yup/lib/boolean';
import number from 'yup/lib/number';
import object from 'yup/lib/object';
import string from 'yup/lib/string';

// const atLeastOne = () => new boolean().test("oneOf", "Please select at least one checkbox", function() {
//   return this.parent.pricingRequest || this.parent.productLeadTime || this.parent.requestMeeting || this.parent.installationImagery || this.parent.other || this.parent.message;
// });

export const getValidationSchema = () =>
  new object({
    representative: new object({
      label: new string().required(),
      value: new number().required(),
    }).required('A representative is required!'),
    message: new string(),
    pricingRequest: new boolean(),
    productLeadTime: new boolean(),
    requestMeeting: new boolean(),
    installationImagery: new boolean(),
    other: new boolean(),
  });
